<!-- TODO how to show anonymous  -->

<mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>

<div class="spinner" *ngIf="loading"><mat-progress-spinner mode="indeterminate"></mat-progress-spinner></div>

<div class="layout-container" *ngIf="!loading">
	<div class="row mx-0 mb-3">
		<div class="col d-flex px-0 fg-purple cursor-pointer" [routerLink]="['/user/' + user['userID'] + '/ads']">
			<mat-icon class="mat-icon-rtl-mirror fs-18px">arrow_back</mat-icon>
			<span class="fs-14px">{{ locale.translations['ads']['ad']['n663'] }}</span>
		</div>
	</div>

	<span class="d-block fs-20px fw-500 mb-1">{{ missedCalls.data.length }} {{ locale.translations['ads']['ad']['n644'] }}</span>
	<span class="d-block fs-14px fg-purple">{{ missedCalls['ad']['title'] }}</span>

	<!-- blue box -->
	<div class="blue-box mt-3" *ngIf="missedCalls['ad']['isBasic']">
		<mat-icon class="fs-18px align-middle mat-icon-rtl-mirror blue text-center" [ngClass]="{ 'ms-2': locale.lang !== 'en' }">phone_missed</mat-icon>
		<p class="fs-14px mb-0 mx-2 blue">{{ locale.translations['ads']['ad']['n650'] }}</p>
	</div>

	<!-- missed call detail -->

	<div class="missed-calls-list">
		<div class="row mx-0 purple-box my-3 p-3" *ngFor="let adList of missedCalls['data']">
			<div class="col-md col-12 px-0">
				<span class="d-block fs-16px fw-500 mb-1">
					{{ locale.translations['ads']['ad']['n645'] }}
					<span class="fg-purple">
						{{ !adList['phone'] || adList['phone'].trim() === '' ? locale.translations['ads']['ad']['n647'] : adList['phone'] }}
					</span>
				</span>
				<p class="fs-14px fg-grey mb-3" [ngClass]="{ 'mb-0': viewport.type !== 'mobile' }">
					{{ adList['created_at'] | timezoneConversion | date : 'MMMM d, yyyy h:mm a' }}
				</p>
			</div>
			<div class="col-md col-12 px-0 d-flex cursor-pointer fg-purple line-normal" [ngClass]="{ 'justify-content-end ': viewport.type === 'desktop' }">
				<ng-template [ngIf]="adList['phone']" [ngIfElse]="isAnonymous">
					<div
						class="d-inline-block"
						(click)="missedCalls['ad']['isBasic'] || missedCalls['ad']['isVip'] === '1' ? copyNumber(adList['phone']) : onOpenBoostAdDialog()"
					>
						<img class="clipboard" [src]="'assets/favicon/copy-filled.svg' | s3Image" alt="copy" />
						<span class="fs-14px mx-1">
							{{ locale.translations['ads']['ad']['n646'] }}
						</span>
					</div>
					<div
						class="d-inline-block ms-16px"
						*ngIf="viewport.type !== 'mobile' && missedCalls['ad']['isBasic'] === 0 && missedCalls['ad']['isVip'] === '0'"
					>
						<img class="clipboard mx-1" [src]="'assets/icons/eye-filled.svg' | s3Image" alt="view" (click)="onOpenBoostAdDialog()" />
						<span class="fs-14px" (click)="onOpenBoostAdDialog()">
							{{ locale.translations['ads']['ad']['n664'] }}
						</span>
					</div>
					<mat-icon
						*ngIf="viewport.type === 'mobile'"
						class="mat-icon-rtl-mirror fs-18px fw-400 mx-1 ms-16px"
						(click)="missedCalls['ad']['isBasic'] || missedCalls['ad']['isVip'] === '1' ? onCall(adList['phone']) : onOpenBoostAdDialog()"
					>
						phone
					</mat-icon>
					<span
						*ngIf="viewport.type === 'mobile'"
						class="fs-14px"
						(click)="missedCalls['ad']['isBasic'] || missedCalls['ad']['isVip'] === '1' ? onCall(adList['phone']) : onOpenBoostAdDialog()"
					>
						{{ locale.translations['dealer']['n353'] }}
					</span>
				</ng-template>

				<ng-template #isAnonymous>
					<!-- info icon for anonymous user -->
					<div class="d-flex justify-content-start fg-light-grey anonymous-msg">
						<img class="info-img mx-1" [src]="'assets/icons/info-circle.svg' | s3Image" alt="info" />
						<span class="fs-11px">{{ locale.translations['ads']['ad']['n648'] }}</span>
					</div>
				</ng-template>
			</div>
		</div>
	</div>
	<div class="row mx-0 mb-3" *ngIf="!missedCalls['ad']['isBasic'] && missedCalls['ad']['isVip'] === '0' && missedCalls['ad']['isVipPlus'] === '0'">
		<div class="col-12 px-0">
			<!-- orange box -->
			<div class="red-box my-3">
				<mat-icon class="missed-call-icon align-middle mat-icon-rtl-mirror light-orange text-center" [ngClass]="{ 'ms-2': locale.lang !== 'en' }">
					phone_missed
				</mat-icon>
				<p class="fs-14px mb-0 fw-500 mx-2 light-orange">{{ locale.translations['ads']['ad']['n649'] }}</p>
			</div>
		</div>
		<div class="col-12 text-center px-0">
			<button
				mat-flat-button
				type="button"
				class="checkout-btn w-50 mb-2 fw-400"
				[ngClass]="{ 'w-100': viewport.type !== 'desktop' }"
				color="primary"
				(click)="onOpenBoostAdDialog()"
			>
				{{ locale.translations['payment']['n342'] | titlecase }}
			</button>
		</div>
	</div>
</div>
